// extracted by css-extract-rspack-plugin
export default {"issueTypeFilterButton":"ListIssueTypeFilter-module__issueTypeFilterButton__H9Mgs"};